export { Iconify } from "./Iconify";
export type { IconifyProps } from "./Iconify";
